import { render, staticRenderFns } from "./PopupTableBtn.vue?vue&type=template&id=fdd91eea&scoped=true"
import script from "./PopupTableBtn.vue?vue&type=script&lang=js"
export * from "./PopupTableBtn.vue?vue&type=script&lang=js"
import style0 from "./PopupTableBtn.vue?vue&type=style&index=0&id=fdd91eea&scoped=true&lang=css"
import style1 from "./PopupTableBtn.vue?vue&type=style&index=1&id=fdd91eea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd91eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdd91eea')) {
      api.createRecord('fdd91eea', component.options)
    } else {
      api.reload('fdd91eea', component.options)
    }
    module.hot.accept("./PopupTableBtn.vue?vue&type=template&id=fdd91eea&scoped=true", function () {
      api.rerender('fdd91eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/form/button/PopupTableBtn.vue"
export default component.exports